import React from 'react'
import { FeatherSVG } from 'stylist'

const CancelCircle = props => (
  <FeatherSVG {...props}>
    <title>cancel-circle</title>
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </FeatherSVG>
)

export default CancelCircle



// WEBPACK FOOTER //
// ./src/components/icons/CancelCircle.js